(function() { window.GUID_90fe224b_e797_414b_ac94_9f915df94009 = { getGuid: function() { return "90fe224b-e797-414b-ac94-9f915df94009"; } }; })();
var EditEncounterOpp;
(function (EditEncounterOpp) {
    var desktop;
    (function (desktop) {
        CS.FormReady(function (formId) {
            if (formId == "EditSchedules") {
                if (document.HomeId != undefined) {
                    document.HomeId.SelectionChange = function () {
                        if (this.SelectedItem != null) {
                            $('#PlaceId').control().SetValue({ value: this.SelectedItem.value.placeId });
                        }
                    };
                }
                /* en changeant de bracket, on vide les noms des équipes car ils ne seront pas dispo dans le drop down.
    
                 * #############################################################*/
                //$("#FlowBlockId").controlIsLoaded<CompuSport.Controls.DropDown>(function (dropdown) {
                //    dropdown.$DropDown.on('change', function (dropdown) {                  
                //        $('#HomeId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //        $('#AwayId').control<CompuSport.Controls.AutoComplete>().ClearValue();
                //    });
                //});
            }
        });
    })(desktop = EditEncounterOpp.desktop || (EditEncounterOpp.desktop = {}));
})(EditEncounterOpp || (EditEncounterOpp = {}));

//# sourceMappingURL=EditEncounterOpp.desktop.js.map
